import { Text } from "@overmap-ai/blocks"
import { type AssetComment, type Stored, UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import { selectUserById, selectAssetById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../IndexLabels/AssetIndexLabel"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineAssetCommentItemProps {
	assetComment: Stored<AssetComment>
}

export const ProjectTimelineAssetCommentItem = memo<ProjectTimelineAssetCommentItemProps>((props) => {
	const { assetComment } = props

	const user = useAppSelector(selectUserById(assetComment.created_by ?? -1))
	const asset = useAppSelector(selectAssetById(assetComment.asset))!

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ASSET_COMMENT}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;commented on asset&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/assets/$assetId"
					params={{ assetId: asset.uuid }}
				>
					<AssetTypeIcon className="align-sub" assetTypeId={asset.asset_type} />
					&nbsp;
					<Text className={interactiveTextCva()} accentColor="base">
						<AssetIndexLabel assetId={asset.uuid} highContrast />
						&nbsp;
						<Text>{asset.label || UNLABELLED_ASSET_LABEL}</Text>
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(assetComment.submitted_at)}</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineAssetCommentItem.displayName = "ProjectTimelineAssetCommentItem"
